module.exports = __webpack_public_path__ + "media/tick1.595fb7ad.webm";